// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Navbar_imgNavigate__Z1X4n{
    width: 40px;

    border-radius: 0.5rem;

}
.Navbar_wrapperFuncPhone__nUnQV{
    display: flex;
    justify-content: center;
    gap:20px;

}
.Navbar_fadeOutFooter__\\+LbXp{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8); /* Полупрозрачный черный фон */
    
    z-index: 10000; /* Задаем высокий z-index для модального окна */
    cursor: pointer;
}
.Navbar_fadeOutGames__iJp0Q{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8); /* Полупрозрачный черный фон */
    
    z-index: 9998; /* Задаем высокий z-index для модального окна */
    cursor: pointer;
}
.Navbar_blockIcon__qkrI7{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap:3px;
    color: #8b97b6;
    font-size: 14px;
    font-family: Popins,sans-serif;
    cursor: pointer;
}
.Navbar_blockIconSnake__YlIId{
    padding: 5px;
    background-color: #2e6fc4;
    border-radius: 20px;
}
.Navbar_containerGamesF__ZF3Gb {
    
    
    
    display: flex;
    gap: 10px;
    overflow-x: auto; /* Включаем горизонтальную прокрутку */
    overflow-y: hidden; /* Отключаем вертикальную прокрутку */
    white-space: nowrap; /* Предотвращаем перенос строк */
    padding-bottom: 15px; /* Добавляем отступ снизу для удобства прокрутки */
    -webkit-overflow-scrolling: touch; /* Оптимизация для мобильных устройств */
    overflow-x: auto;
    flex-direction: column;
    animation: Navbar_fadeIn__0GhEX 0.3s ease-in-out; /* Длительность 1 секунда с плавным входом и выходом */

    
}

.Navbar_blockGameF__hYTim{
    display: flex;
    gap:10px;
    white-space: nowrap;
    background-color: #111d2eeb;
    border-radius: 20px;
    padding:5px;
    align-items: center;
    color:white;
    font-size: 16px;
    font-family: Popins,sans-serif;
}
.Navbar_blockIcon__qkrI7 i{
    font-size: 20px;
    color: #8b97b6;

}
.Navbar_activeF__JR--h,.Navbar_activeF__JR--h i{
    color:white;

}
.Navbar_containerInfHeader__xdlh0{
    display: flex;
    flex-direction: row;
    
    align-items: center;
}
.Navbar_buttonsHeader__1-MFG{
    display: flex;
    align-items: center;
    justify-content: center;
    gap:5px;
    padding: 10px;
    border-radius: 10px;
    font-size: 30px;



}
.Navbar_activeBlockGamef__JIJCj{
    background-color: rgb(55 134 55 / 81%);
}
@keyframes Navbar_fadeIn__0GhEX {
    from {
        opacity: 0;
        transform: translateY(200px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}
@media screen and (min-width: 1000px) {
    .Navbar_buttonsHeader__1-MFG {
        font-size: 10px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Navbar/Navbar.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;;IAEX,qBAAqB;;AAEzB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,QAAQ;;AAEZ;AACA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC,EAAE,8BAA8B;;IAEpE,cAAc,EAAE,+CAA+C;IAC/D,eAAe;AACnB;AACA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC,EAAE,8BAA8B;;IAEpE,aAAa,EAAE,+CAA+C;IAC9D,eAAe;AACnB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,OAAO;IACP,cAAc;IACd,eAAe;IACf,8BAA8B;IAC9B,eAAe;AACnB;AACA;IACI,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;AACvB;AACA;;;;IAII,aAAa;IACb,SAAS;IACT,gBAAgB,EAAE,sCAAsC;IACxD,kBAAkB,EAAE,qCAAqC;IACzD,mBAAmB,EAAE,gCAAgC;IACrD,oBAAoB,EAAE,kDAAkD;IACxE,iCAAiC,EAAE,wCAAwC;IAC3E,gBAAgB;IAChB,sBAAsB;IACtB,gDAAkC,EAAE,sDAAsD;;;AAG9F;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB,2BAA2B;IAC3B,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,8BAA8B;AAClC;AACA;IACI,eAAe;IACf,cAAc;;AAElB;AACA;IACI,WAAW;;AAEf;AACA;IACI,aAAa;IACb,mBAAmB;;IAEnB,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,OAAO;IACP,aAAa;IACb,mBAAmB;IACnB,eAAe;;;;AAInB;AACA;IACI,sCAAsC;AAC1C;AACA;IACI;QACI,UAAU;QACV,4BAA4B;IAChC;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;AACA;IACI;QACI,eAAe;IACnB;AACJ","sourcesContent":[".imgNavigate{\n    width: 40px;\n\n    border-radius: 0.5rem;\n\n}\n.wrapperFuncPhone{\n    display: flex;\n    justify-content: center;\n    gap:20px;\n\n}\n.fadeOutFooter{\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.8); /* Полупрозрачный черный фон */\n    \n    z-index: 10000; /* Задаем высокий z-index для модального окна */\n    cursor: pointer;\n}\n.fadeOutGames{\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.8); /* Полупрозрачный черный фон */\n    \n    z-index: 9998; /* Задаем высокий z-index для модального окна */\n    cursor: pointer;\n}\n.blockIcon{\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap:3px;\n    color: #8b97b6;\n    font-size: 14px;\n    font-family: Popins,sans-serif;\n    cursor: pointer;\n}\n.blockIconSnake{\n    padding: 5px;\n    background-color: #2e6fc4;\n    border-radius: 20px;\n}\n.containerGamesF {\n    \n    \n    \n    display: flex;\n    gap: 10px;\n    overflow-x: auto; /* Включаем горизонтальную прокрутку */\n    overflow-y: hidden; /* Отключаем вертикальную прокрутку */\n    white-space: nowrap; /* Предотвращаем перенос строк */\n    padding-bottom: 15px; /* Добавляем отступ снизу для удобства прокрутки */\n    -webkit-overflow-scrolling: touch; /* Оптимизация для мобильных устройств */\n    overflow-x: auto;\n    flex-direction: column;\n    animation: fadeIn 0.3s ease-in-out; /* Длительность 1 секунда с плавным входом и выходом */\n\n    \n}\n\n.blockGameF{\n    display: flex;\n    gap:10px;\n    white-space: nowrap;\n    background-color: #111d2eeb;\n    border-radius: 20px;\n    padding:5px;\n    align-items: center;\n    color:white;\n    font-size: 16px;\n    font-family: Popins,sans-serif;\n}\n.blockIcon i{\n    font-size: 20px;\n    color: #8b97b6;\n\n}\n.activeF,.activeF i{\n    color:white;\n\n}\n.containerInfHeader{\n    display: flex;\n    flex-direction: row;\n    \n    align-items: center;\n}\n.buttonsHeader{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap:5px;\n    padding: 10px;\n    border-radius: 10px;\n    font-size: 30px;\n\n\n\n}\n.activeBlockGamef{\n    background-color: rgb(55 134 55 / 81%);\n}\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n        transform: translateY(200px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n@media screen and (min-width: 1000px) {\n    .buttonsHeader {\n        font-size: 10px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"imgNavigate": `Navbar_imgNavigate__Z1X4n`,
	"wrapperFuncPhone": `Navbar_wrapperFuncPhone__nUnQV`,
	"fadeOutFooter": `Navbar_fadeOutFooter__+LbXp`,
	"fadeOutGames": `Navbar_fadeOutGames__iJp0Q`,
	"blockIcon": `Navbar_blockIcon__qkrI7`,
	"blockIconSnake": `Navbar_blockIconSnake__YlIId`,
	"containerGamesF": `Navbar_containerGamesF__ZF3Gb`,
	"fadeIn": `Navbar_fadeIn__0GhEX`,
	"blockGameF": `Navbar_blockGameF__hYTim`,
	"activeF": `Navbar_activeF__JR--h`,
	"containerInfHeader": `Navbar_containerInfHeader__xdlh0`,
	"buttonsHeader": `Navbar_buttonsHeader__1-MFG`,
	"activeBlockGamef": `Navbar_activeBlockGamef__JIJCj`
};
export default ___CSS_LOADER_EXPORT___;
